import React from 'react'
import { useSelector } from 'react-redux'
import { useTradeinContext } from '../hooks/useTradeinContext'
import { IConfigSeller } from '@/models/configSeller'

const Client: React.FC<any> = () => {
  const { ctx } = useTradeinContext()
  const configSeller = useSelector((store: { config: IConfigSeller }) => store.config)
  const isCoppel = configSeller.config.s3.FOLDER_APP === 'ti_coppel'
  const isRipleyChile = configSeller.config.s3.FOLDER_APP === 'ti_ripley_cl'
  const isWom = configSeller.config.s3.FOLDER_APP === 'ti_wom'

  return (
    <div className='bg-white rounded-lg shadow-lg p-4'>
      <h6 className='border-b-1 mb-2 font-bold text-xl pb-2'>Cliente</h6>
      <div className='grid grid-cols-12 gap-4'>
        <div className='col-span-12 md:col-span-4'>
          <p><strong>Nombre:</strong> {ctx.tradein.name + ' ' + (ctx.tradein.lastname !== null ? ctx.tradein.lastname : '')}</p>
        </div>
        <div className='col-span-12 md:col-span-4'>
          <p><strong>Email:</strong> {ctx.tradein.email}</p>
        </div>
        <div className='col-span-12 md:col-span-4'>
          {ctx.tradein.rut !== null ? <p><strong>{String(import.meta.env.VITE_LABEL_RUT).toUpperCase()}: </strong> {ctx.tradein.rut} </p> : null}
        </div>
        <div className='col-span-12 md:col-span-4' hidden={ctx.tradein.store === null}>
          <p><strong>Tienda: </strong> {isCoppel ? `${ctx.tradein.seller_store_number} - ${ctx.tradein.store}` : ctx.tradein.store} </p>
        </div>
        <div className='col-span-12 md:col-span-4' hidden={ctx.tradein.phone === null}>
          <p><strong>Telefono: </strong> {ctx.tradein.phone} </p>
        </div>
        <div className='col-span-12 md:col-span-4' hidden={ctx.tradein.folio_coppel === null}>
          <p><strong>Folio: </strong> {ctx.tradein.folio_coppel} </p>
        </div>
        <div className='col-span-12 md:col-span-4' hidden={ctx.tradein.document_cupon_used === null}>
          <p><strong>Documento: </strong> {ctx.tradein.document_cupon_used} </p>
        </div>
        <div className='col-span-12 md:col-span-4' hidden={ctx.tradein.device_purchased === null}>
          <p><strong>Dispositivo Comprado: </strong> {ctx.tradein.device_purchased} </p>
        </div>
        <div className='col-span-12 md:col-span-4' hidden={!isRipleyChile || !ctx.tradein.ripley_card_number}>
          <p><strong>Giftcard Ripley: </strong> {ctx.tradein.ripley_card_number} </p>
        </div>
        <div className='col-span-12 md:col-span-4' hidden={!isWom || !ctx.tradein.device_purchased || !ctx.tradein.device_plan}>
          <p><strong>Plan Cliente: </strong> {ctx.tradein.device_plan} </p>
        </div>
      </div>
    </div>
  )
}

export default Client
